module.exports = __webpack_public_path__ + "img/QianShu.894e7fd3.png";